import {
  CreateReplacementAdminRequest,
  DeleteReplacementAdminRequest,
  ListReplacementsAdminRequest,
  ListReplacementsAdminResponse,
  OrderBetween,
  Replacement,
  UpdateReplacementAdminRequest,
} from "@safetyculture/s12-apis-connect-web/s12/accounts/admin/v1/white_label_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

export const ListWhiteLabelReplacements = async (
  orgId: string,
  headers: Record<RequestMetadata, string>,
): Promise<ListReplacementsAdminResponse> => {
  const req = new ListReplacementsAdminRequest({
    orgId: orgId,
  });

  return supportServiceConnectClient.listWhiteLabelReplacements(req, {
    headers,
  });
};

export const CreateWhiteLabelReplacement = async (
  orgId: string,
  searchValue: string,
  replaceValue: string,
  order: OrderBetween,
  headers: Record<RequestMetadata, string>,
): Promise<Replacement> => {
  const req = new CreateReplacementAdminRequest({
    orgId: orgId,
    searchValue: searchValue,
    replaceValue: replaceValue,
    order: order,
  });

  return supportServiceConnectClient.createWhiteLabelReplacement(req, {
    headers,
  });
};

type UpdateWhiteLabelReplacementParams = {
  orgId: string;
  id: string;
  searchValue: string;
  replaceValue: string;
  order?: OrderBetween;
};

export const UpdateWhiteLabelReplacement = async (
  {
    orgId,
    id,
    searchValue,
    replaceValue,
    order,
  }: UpdateWhiteLabelReplacementParams,
  headers: Record<RequestMetadata, string>,
): Promise<Replacement> => {
  const req = new UpdateReplacementAdminRequest({
    orgId,
    id,
    searchValue,
    replaceValue,
    order,
  });

  return supportServiceConnectClient.updateWhiteLabelReplacement(req, {
    headers,
  });
};

export const DeleteWhiteLabelReplacement = async (
  orgId: string,
  replacementId: string,
  headers: Record<RequestMetadata, string>,
) => {
  const req = new DeleteReplacementAdminRequest({
    orgId: orgId,
    id: replacementId,
  });

  return supportServiceConnectClient.deleteWhiteLabelReplacement(req, {
    headers,
  });
};
